module.exports = __webpack_public_path__ + "media/store/images/Rectangle 6-9a22e1b67262d1c96285ef4a160b00a3.png";